import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom'; // Import necessary libraries
import ScrollToTopOnMount from './ScrollToTopOnMount';


import "./PreCheckOut.scss";

export function PreCheckOut() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the window when the component mounts
  }, []); // Empty dependency array ensures the effect runs only once when the component mounts

  const { eventId } = useParams();
  const location = useLocation(); // Get current location
  const navigate = useNavigate();
  const [selectedDateButton, setSelectedDateButton] = useState([]);
  const [eventChosen, setEventChosen] = useState([]);
  const [subtotal, setSubtotal] = useState(0); // Initialize subtotal state
  const [generalAdmissionTickets, setGeneralAdmissionTickets] = useState(0); // Initialize state for general admission tickets
  const [studentTickets, setStudentTickets] = useState(0); // Initialize state for student tickets
  const [selectedTimeButton, setSelectedTimeButton] = useState(null);
  const [selectedEventInstance, setSelectedEventIntance] = useState([]);
  const [studentTickeTypetId, setStudentTicketTypeId] = useState([]);
  const [generalTickeTypetId, setGeneralTicketTypeId] = useState([]);
  const [seatingId, setSeatingId] = useState([]);
  // State for ticket selections
  const [ticketSelections, setTicketSelections] = useState([]);

  const formatDate = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "long" });
    const dateNumber = dateObj.getDate();
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${day} • ${month} ${dateNumber}`;
  };

  const formatDateTwo = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "short" });
    const dateNumber = dateObj.getDate();
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${day}, ${month} ${dateNumber}`;
  };

  const getDayOfWeek = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj
      .toLocaleDateString("en-US", { weekday: "short" })
      .slice(0, 3);
  };

  const getDateNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.getDate();
  };

  const getMonthName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { month: "long" });
  };

  const getYearName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { year: "numeric" });
  };

  const getTimeNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
  };

  function scrollToSection(EventInfo) {
    const section = document.getElementById(EventInfo);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Function to extract video ID from YouTube URL
  const extractVideoId = (videoLink) => {
    const urlParams = new URLSearchParams(videoLink.split('?')[1]);
    return urlParams.get('v');
  };


  const handleNavigateBack = () => {
    // Determine the previous location
    if (location.state && location.state.from) {
      navigate(location.state.from); // Navigate back to the previous location
    } else {
      navigate(-1); // Navigate back one step in the history stack as fallback
    }
  };

  // Retrieve customEventDetails from localStorage
  const customEventDetails = JSON.parse(localStorage.getItem('customEventDetails'));

  // Retrieve customEventDetails from localStorage
  const eventDate = JSON.parse(localStorage.getItem('eventDate'));

  // Extract values from the location.state object
  const eventDetails = customEventDetails;

  // Extract value from the location.eventDate object
  const eventDateNumber = getDateNumber(eventDate);

  // Extract value from the location.eventDate object
  const eventDateMonth = getMonthName(eventDate);

  // Extract value from the location.eventDate object
  const eventDateYear = getYearName(eventDate);

  // Extract the 'events' property from eventDetails
  const events = eventDetails.flat();

  console.log(eventId);

  // Filter events where isOnSale is true
  const onSaleEvents = events
    .filter(event => event.isOnSale) // Filter events where isOnSale is true
    .filter(event => event.start);   // Filter events where start is defined

  // Find the event with the matching eventId
  const selectedEvent = onSaleEvents.filter(event => event.id === eventId);

  // Find all events with the matching eventDate
  const selectedDate = selectedEvent.filter(event => getDateNumber(event.start) === eventDateNumber && getMonthName(event.start) === eventDateMonth && getYearName(event.start) === eventDateYear);

  const MAX_SELECTIONS = 1; // Define the maximum number of selections allowed

  // Function to handle selection of dates
  const handleDateButtonSelection = (date) => {
    setSelectedTimeButton(null);
    // Toggle selection of dates
    if (selectedDateButton.includes(date)) {
      setSelectedDateButton(selectedDateButton.filter(selectedDate => selectedDate !== date));
    } else {
      // Remove the last entry if the array length exceeds the maximum allowed
      if (selectedDateButton.length >= MAX_SELECTIONS) {
        const updatedSelections = selectedDateButton.slice(1); // Remove the first element
        setSelectedDateButton([...updatedSelections, date]);
      } else {
        setSelectedDateButton([...selectedDateButton, date]);
      }
    }
  };

  // Function to handle click on date button
  const handleClickDateButton = (date) => {
    handleDateButtonSelection(date); // Call the handleDateButtonSelection function
  };

  // Function to check if a time button should be clickable
  const isTimeButtonClickable = (startTime, clickedDate) => {
    const eventChosen = selectedEvent.filter(item => item.start === startTime);
    setEventChosen(eventChosen);
    console.log("Instance Chosen:", eventChosen);
    if (eventChosen) {
      const eventDate = new Date(eventChosen.start).toDateString();
      setSelectedTimeButton(startTime);
      setSelectedEventIntance(eventChosen[0].instanceId)
      setSeatingId(eventChosen[0].planId)
      setStudentTicketTypeId(eventChosen[0].studentTicketTypeId); // Set the student ticket type ID
      setGeneralTicketTypeId(eventChosen[0].generalTicketTypeId); // Set the general ticket type ID
      setTicketSelections(eventChosen[0].ticketData);

      return eventDate === clickedDate;
    }
    return false;
  };

  // Function to handle change in ticket selection
  const handleTicketChange = (index, value) => {
    // Update the value at the specified index
    const updatedTicketSelections = [...ticketSelections];
    updatedTicketSelections[index].quantity = value;

    // Calculate total number of tickets selected
    const totalTicketsSelected = updatedTicketSelections.reduce((total, ticket) => {
      return total + (ticket.quantity || 0);
    }, 0);

    if (totalTicketsSelected <= 10) {
      setTicketSelections(updatedTicketSelections);
      calculateSubtotal(); // Recalculate subtotal
    } else {
      // Rollback the quantity change for the current ticket
      updatedTicketSelections[index].quantity -= value;
    }
  };

  // Function to calculate subtotal based on ticket selections
  const calculateSubtotal = () => {
    let total = 0;
    ticketSelections.forEach(ticket => {
      // Ensure ticket object has necessary properties
      if (ticket.ticketAmount !== undefined && ticket.commissionAmount !== undefined && ticket.quantity !== undefined) {
        // Calculate total for each ticket type
        total += (ticket.ticketAmount + ticket.commissionAmount) * ticket.quantity;
      }
    });
    setSubtotal(total.toFixed(2));
  };

  //const remainingTickets = 10 - ticketSelections.reduce((total, ticket) => total + ticket.quantity, 0);

  const handleCheckout = () => {
    // Initialize an empty array to store ticket request objects
    const requestBody = [];
    //window.location.replace('https://ch9.7de.myftpupload.com/checkout/');

    // Loop through each ticket selection
    ticketSelections.forEach(ticket => {
      // Loop based on the quantity of tickets selected for this type
      for (let i = 0; i < ticket.quantity; i++) {
        // Construct a request object for each ticket and add it to the requestBody array
        requestBody.push({
          instance: selectedEventInstance,
          seatingPlan: seatingId,
          type: ticket.ticketTypeId // Using ticketTypId from ticketSelections
        });
      }
    });

    // Log the requestBody
    console.log('Request Body:', requestBody);

    // Make the POST request
    fetch('https://system.spektrix.com/jazzforumarts_staging/api/v3/basket/tickets', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody),
      credentials: 'include' // Include cookies
    })
      .then(response => {
        if (response.ok) {
          console.log('Request successful');
          console.log(requestBody);
          // Optionally, you can handle redirection or display a success message to the user
          // Open a new tab with the external URL
          window.open('https://ch9.7de.myftpupload.com/cart/', '_top');

          // Close the current tab
          //window.close();
          // Send a message to the parent window to request redirection
          //window.parent.postMessage({ type: 'checkout' }, '*');
        } else {
          // Handle error response
          console.error('Request failed with status:', response.status);
          // Optionally, you can extract error information from the response body
          response.json().then(errorData => {
            console.error('Error:', errorData);
            // Optionally, you can display an error message to the user
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Optionally, you can display an error message to the user
      });
  };

  console.log(selectedEvent);

  return (
    <>
      <ScrollToTopOnMount />

      <div className="animate-fadeIn md:ml-25 antialiased" style={{
        minHeight: "auto",
        maxHeight: "100%",
        width: "100%",
        height: "100%",
        padding: "0px 10px",
        justifyContent: "flext-start"
      }}> {/* Ensure each key is unique */}
        <div style={{
          alignItems: "center",
          justifyContent: "flex-start",
          paddingBottom: "5px",
        }}>
          <button onClick={handleNavigateBack} style={{
            width: "auto",
            maxWidth: "100%",
            fontFamily: "Montserrat, sans-serif",
            textTransform: "uppercase",
            //letterSpacing: "1.5px",
            fontSize: "1.2rem",
            height: "40px",
            background: "none",
            border: "none",
            borderRadius: "none",
            display: "inline-flex",
            lineHeight: "1.5rem",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "0 20px !important", // Override Elementor padding
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "white",
            textDecoration: "none", // Remove default link underline
          }}>
            <span style={{ display: "flex", alignItems: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 24"
                strokeWidth={3} stroke="currentColor" className="w-3 h-3"
                style={{ marginRight: "5px", cursor: "pointer" }}>
                <path strokeLinecap="round" strokeLinejoin="round"
                  d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
              </svg>
              <span className="leading-tight text-xxm sm:text-xl" style={{
                width: "auto",
                maxWidth: "100%",
                fontFamily: "Montserrat, sans-serif",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}>See all events</span>
            </span>
          </button>
        </div>

        {/* Check if there is at least one event in selectedDate */}
        {selectedDate.length > 0 && (
          <li className="content-center" key={selectedDate[0].instanceId} style={{ minHeight: "200px", minWidth: "100%", maxWidth: "100%" }}>
            {/*existing event instance rendering logic */}
            <div className="grid place-content-center gap-1 grid-cols-1">
              <div style={{ width: "fit-content" }}>
                <div className="flex flex-col sm:flex-row">
                  {/* Render the event image */}
                  <div className="pb-2">
                    <img
                      src={selectedDate[0].imageUrl}
                      alt={selectedDate[0].name}
                      className="object-cover w-full h-full"
                      style={{
                        objectFit: "contain",
                        objectPosition: "top", // Position the image at the top
                      }}
                    />
                  </div>
                  {/* Render the event information */}
                  <div className="w-full pb-2 sm:px-5">
                    <h3 className="text-3xl text-left" style={{
                      fontFamily: "Norwester, sans-serif",
                      textTransform: "uppercase",
                      fontStyle: "normal",
                      color: "white",
                      lineHeight: "1", // Increase the line height (leading)
                    }}>{selectedDate[0].name}</h3>
                    <div className="text-2xl">
                      <h4 style={{
                        fontFamily: "Norwester, sans-serif",
                        textTransform: "uppercase",
                        fontStyle: "normal",
                        color: "white",
                        paddingBottom: "3px",
                        margin: "0", // Add margin
                      }}>{selectedDate[0].attribute_Subtitle}</h4>
                    </div>
                    <div className="pb-2">
                      <h1 className="text-left" style={{ margin: "0" }}>
                        <p style={{
                          fontFamily: "Montserrat, sans-serif",
                          textTransform: "none",
                          fontStyle: "normal",
                          color: "white",
                          paddingBottom: "3px",
                          fontWeight: "bold",
                          margin: "0", // Add margin
                        }}>{selectedDate[0].attribute_SpecialInformation}</p>
                      </h1>
                    </div>
                    <div className="pb-2">
                      <h1 className="text-left" style={{ margin: "0" }}>
                        <p style={{
                          fontFamily: "Montserrat, sans-serif",
                          textTransform: "none",
                          fontStyle: "normal",
                          color: "white",
                          paddingBottom: "3px",
                          margin: "0", // Add margin
                        }}>{selectedDate[0].attribute_FeaturedArtists}</p>
                      </h1>
                    </div>
                    <div>
                      <div>
                        <button onClick={() => scrollToSection("sectionId")} style={{
                          width: "auto",
                          maxWidth: "100%",
                          fontFamily: "Montserrat, sans-serif",
                          textTransform: "uppercase",
                          //letterSpacing: "1.5px",
                          fontSize: "1.2rem",
                          height: "40px",
                          background: "none",
                          border: "none",
                          borderRadius: "none",
                          display: "inline-flex",
                          lineHeight: "1.5rem",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          padding: "0 20px !important", // Override Elementor padding
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "white",
                          textDecoration: "none", // Remove default link underline
                        }}>
                          <span onClick={() => scrollToSection("EventInfo")} style={{ display: "flex", alignItems: "center" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                              stroke="currentColor" class="w-3 h-3" style={{ marginRight: "5px", cursor: "pointer" }}>
                              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                            </svg>
                            <span className="leading-tight text-xxm sm:text-xl" style={{
                              width: "auto",
                              maxWidth: "100%",
                              fontFamily: "Montserrat, sans-serif",
                              textTransform: "uppercase",
                              fontWeight: "bold",
                            }}>Scroll to see more event info</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-row sm:flex-col">
                  <div className="w-full pb-10">
                    <section className="ExtraInfo">
                      {/* Render tags and event category within a single div */}
                      <div className="text-align-center">
                        {/* Conditionally render tag 1 if it's not null */}
                        {selectedDate[0].attribute_EventTag1 && (
                          <label className="inline-flex justify-center items-center text-xxxs sm:text-ms" style={{
                            padding: "5px",
                            fontWeight: "lighter",
                            color: "white",
                            letterSpacing: "2px",
                            lineHeight: "1",
                            //fontSize: ".8rem",
                            background: "#2D2D2D",
                            fontFamily: "Montserrat, sans-serif",
                            textTransform: "uppercase",
                            marginRight: "6px", // Add margin between tags
                          }}>
                            {selectedDate[0].attribute_EventTag1}
                          </label>
                        )}
                        {/* Conditionally render tag 2 if it's not null */}
                        {selectedDate[0].attribute_EventTag2 && (
                          <label className="inline-flex justify-center items-center text-xxxs sm:text-ms" style={{
                            padding: "5px",
                            fontWeight: "lighter",
                            color: "white",
                            letterSpacing: "2px",
                            lineHeight: "1",
                            //fontSize: ".8rem",
                            background: "#2D2D2D",
                            fontFamily: "Montserrat, sans-serif",
                            textTransform: "uppercase",
                            marginRight: "6px", // Add margin between tags
                          }}>
                            {selectedDate[0].attribute_EventTag2}
                          </label>

                        )}
                        {/* Conditionally render tag 3 if it's not null */}
                        {selectedDate[0].attribute_EventTag3 && (
                          <label className="inline-flex justify-center items-center text-xxxs sm:text-ms" style={{
                            padding: "5px",
                            fontWeight: "lighter",
                            color: "white",
                            letterSpacing: "2px",
                            lineHeight: "1",
                            //fontSize: ".8rem",
                            background: "#2D2D2D",
                            fontFamily: "Montserrat, sans-serif",
                            textTransform: "uppercase",
                            marginRight: "3px", // Add margin between tags
                          }}>
                            {selectedDate[0].attribute_EventTag3}
                          </label>
                        )}
                        {/* Conditionally render Event Category if it's not null */}
                        {selectedDate[0].attribute_EventCategory && (
                          <p className="inline-flex justify-center items-center text-xxxs sm:text-ms" style={{
                            padding: "5px",
                            fontWeight: "lighter",
                            color: "white",
                            letterSpacing: "2px",
                            lineHeight: "1",
                            //fontSize: ".8rem",
                            //background: "#2D2D2D",
                            fontFamily: "Montserrat, sans-serif",
                            textTransform: "uppercase",
                            fontStyle: "italic", // Apply cursive font style
                            marginRight: "3px", // Add margin between tags
                          }}>
                            {selectedDate[0].attribute_EventCategory}
                          </p>
                        )}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div >
          </li >
        )
        }

        {/* Ticket Date/Time Section */}
        <div className="" style={{
          width: "auto", /* Set the width of the square */
          height: "auto", /* Set the height of the square */
          background: "#2D2D2D", /* Set the background color */
          display: "flex", /* Use flexbox for centering */
          justifyContent: "left", /* Center horizontally */
          alignItems: "left", /* Center vertically */
          margin: "0 auto", /* Center horizontally */
          padding: "0px 20px",
          minHeight: "100%",
          maxHeight: "100%",
          width: "100%",
          height: "100%",
        }}>
          <section>
            {/* Section: Render Dates and Times for Chosen Event */}
            <div className="py-10">
              {/* Get unique dates */}
              {selectedEvent
                .map(event => new Date(event.start).toDateString()) // Get unique dates as strings
                .filter((date, index, self) => self.indexOf(date) === index) // Filter unique dates
                .map((date, index) => {
                  const currentDate = new Date();
                  return {
                    date: date,
                    isFirstDate: index === 0 && events.length > 0,
                    events: selectedEvent
                      .filter(event => new Date(event.start).toDateString() === date && new Date(event.start) > currentDate)
                  };
                })
                .filter(({ events }) => events.length > 0) // Filter out dates with no valid events
                .map(({ date, events, isFirstDate }) => (
                  <div key={date}>
                    <div className="flex items-left" style={{
                      color: "white",
                      lineHeight: "1",
                      fontSize: "1rem",
                      fontFamily: "Norwester, sans-serif",
                      textTransform: "uppercase",
                    }}>
                      {isFirstDate && (
                        <h4 style={{
                          color: "white",
                          fontSize: "24px",
                          marginRight: "120px", // Add margin between Choose Date and Choose Time
                        }}>Date:</h4>
                      )}
                      {/* Render times for each unique date */}
                      {isFirstDate && <h4 style={{
                        color: "white",
                        fontSize: "24px",
                        paddingBottom: "10px",
                      }}>Time:</h4>}
                    </div>
                    <div className='flex flex-grid-2'>
                      <div className='date-button'>
                        <button className={`p-4 text-white mb-4`}
                          style={{
                            color: selectedDateButton.includes(date) ? "white" : "black",
                            minWidth: "130px",
                            background: selectedDateButton.includes(date) ? "#009ED0" : "white",
                            fontSize: ".85rem",
                            fontFamily: "Montserrat, sans-serif",
                            textTransform: "uppercase",
                          }}
                          onClick={() => handleClickDateButton(date)}
                        >
                          <p className="font-semibold">{formatDate(date)}</p>
                        </button>
                      </div>
                      {/* Render times for each unique date */}
                      <div className='times-button' style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {events.map((event, index) => (
                          <div key={event.instanceId} style={{ flexBasis: '10%', marginBottom: '10px' }}>
                            <button
                              className="p-4 sm:grid-cols-1 ml-10"
                              style={{
                                marginRight: index % 1 === 0 ? "-30px" : "0", // Add margin between buttons in pairs
                                //marginRight: window.innerWidth <= 480 ? "0" : index === 0 ? "0" : "0px", // Add margin only for buttons after the first one
                                //marginBottom: window.innerWidth <= 480 && index > 0 ? "0px" : "0px", // Add margin bottom for buttons after the first one on small screens
                                //paddingRight: index > 0 ? "90" : "", // Apply padding right only to the subsequent times, not the first one
                                fontSize: ".85rem",
                                fontFamily: "Montserrat, sans-serif",
                                textTransform: "uppercase",
                                color: selectedDateButton.includes(date) ? "white" : "black", // Only turn blue when button is active
                                minWidth: "130px",
                                background: "white",
                                color: "black",
                                color: selectedDateButton.includes(date) && event.availableStatus === 0 && "white", // Only turn blue when button is active
                                backgroundColor: event.availableStatus === 0 ? "#B00000" : (selectedTimeButton === event.start ? "#009ED0" : "white"),
                                //color: selectedDateButton.includes(date) && event.availableStatus < 0 ? "white" : "white", // Set initial opacity
                                background: selectedTimeButton !== event.start && "white", // Adjusted color condition
                                color: selectedTimeButton === event.start && "white", // Adjusted color condition
                                position: 'relative', // Position relative for absolute positioning of the icon
                                transition: 'background-color 7s, color 7s', // Transition for background color and text color
                                transition: 'opacity .8s', // Transition for opacity change
                                opacity: selectedDateButton.includes(date) && event.availableStatus > 0 ? 1 : 0.4, // Set initial opacity
                                pointerEvents: selectedDateButton.includes(date) && event.availableStatus > 0 ? "auto" : "none",
                              }}
                              onClick={() => isTimeButtonClickable(event.start, date)}
                            >
                              {event.availableStatus > 0 ? <p>{getTimeNumber(event.start)}</p> : <p>Sold Out</p>}
                              {selectedTimeButton === event.start && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth="1.5"
                                  stroke="currentColor"
                                  className="w-6 h-6"
                                  style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '5px',
                                    color: '#009ED0', // Adjust the color of the checkmark icon
                                  }}
                                >
                                  <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                              )}
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </section>
        </div>

        {/* Choose Ticket Section */}
        {selectedDateButton.length > 0 && selectedTimeButton && (
          <div className="flex flex-row" style={{
            width: "auto", /* Set the width of the square */
            height: "auto", /* Set the height of the square */
            background: "#2D2D2D", /* Set the background color */
            display: "flex", /* Use flexbox for centering */
            justifyContent: "left", /* Center horizontally */
            alignItems: "left", /* Center vertically */
            margin: "0 auto", /* Center horizontally */
            padding: "0px 20px",
            minHeight: "100%",
            maxHeight: "100%",
            width: "100%",
            height: "100%",
          }}>
            <section>
              <div style={{ paddingBottom: "10px" }}></div>
              <div style={{
                color: "white",
                lineHeight: "1",
                fontSize: "1rem",
                fontFamily: "Norwester, sans-serif",
                textTransform: "uppercase",
                paddingBottom: "10px",
              }}>
                <h4 style={{
                  color: "white",
                  fontSize: "24px",
                  paddingBottom: "10px",
                }}>Choose Tickets:</h4>
              </div>
              <div className="">
                {eventChosen[0]?.ticketData?.map((ticketType, index) => (
                  <div key={index} style={{ paddingBottom: "10px", display: "flex", alignItems: "center" }}>
                    <p className="ticket-type-name" htmlFor={`ticketSelect_${index}`} style={{
                      color: "white",
                      maxLines: "2",
                      letterSpacing: "1px",
                      lineHeight: "1",
                      fontSize: "1rem",
                      fontFamily: "Montserrat, sans-serif",
                      marginRight: "12px",
                    }}>{ticketType.ticketTypeName}:</p>
                    <select id={`ticketSelect_${index}`} name={`ticketSelect_${index}`} style={{
                      color: "black",
                      height: "40px",
                      minWidth: "80px", // Add minimum width to the select box
                      maxWidth: "100px", // Add minimum width to the select box
                      fontSize: ".8rem",
                      fontFamily: "Montserrat, sans-serif",
                      textTransform: "uppercase",
                      padding: "10px",
                      border: "1px solid #ccc", // Add border for better visibility
                      // Hide the default dropdown arrow
                      appearance: "none",
                      // Adjust the appearance of the custom dropdown arrow
                      backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="black" class="w-6 h-6"%3E%3Cpath stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" /%3E%3C/svg%3E')`,
                      backgroundRepeat: "no-repeat",
                      backgroundPositionX: "calc(100% - 18px)",
                      backgroundPositionY: "center",
                      backgroundSize: "16px", // Adjust this value to change the size of the arrow
                    }} defaultValue="0"
                      onChange={(event) => handleTicketChange(index, parseInt(event.target.value))}>
                      {[...Array(11).keys()].map(value => (
                        <option key={value} value={value}>{value}</option>
                      ))}
                    </select>
                    {/* Display price and commission */}
                    <div className="flex flex-row items-center">
                      <p style={{
                        color: "white",
                        letterSpacing: "1px",
                        lineHeight: "1",
                        fontSize: "1rem",
                        fontFamily: "Montserrat, sans-serif",
                        marginLeft: "12px",
                        marginRight: "12px", // Add some margin between the elements
                        whiteSpace: "nowrap", // Prevent wrapping to the next line
                        ...(window.innerWidth <= 540 && { // Apply style only in sm (small) screens
                          marginRight: "10px", // Add margin to move closer to the left
                        })
                      }}>{`$${ticketType.ticketAmount} `}(+${ticketType.commissionAmount} fee)</p>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ paddingBottom: "20px" }}></div>
            </section>
          </div >
        )}


        {/* Apply Discount Section */}
        < div style={{ paddingBottom: "10px" }
        }>
          <hr style={{ borderColor: "black", margin: "0 auto", width: "10%" }} /> {/* Divider line */}
          {/* Choose Ticket Section */}
          <div className="flex flex-row" style={{
            width: "auto",
            height: "auto",
            background: "#2D2D2D",
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
            margin: "0 auto",
            paddingBottom: "10px",
            padding: "0px 20px",
          }}>
            <section className="flex flex-col sm:flex-row">
              {/* Discount Code Label and Input */}
              <div className="flex flex-col sm:flex-1 sm:pr-4">
                <div style={{ paddingBottom: "40px" }}></div>
                <div className="relative flex items-center space-x-5 divide-slate-300/60" style={{
                  fontFamily: "Montserrat, sans-serif",
                  textTransform: "none",
                  fontStyle: "normal",
                  color: "white",
                  paddingBottom: "10px",
                  fontSize: "24px",
                }}>
                  <p className="leading-tight text-xxm sm:text-xl" htmlFor="discountCode" style={{
                    color: "white",
                    textTransform: "uppercase",
                    //fontSize: "18px",
                    fontWeight: "bold",
                    fontFamily: "Montserrat, sans-serif",
                  }}>Add Discount Code:</p>
                  <input
                    className=""
                    type="text"
                    id="discountCode"
                    name="discountCode"
                    style={{
                      color: "black",
                      width: "100%", // Adjusted width for mobile
                      maxWidth: "350px", // Maximum width for larger screens
                      height: "40px"
                    }}
                  />
                  <button className="leading-tight text-xxm sm:text-xl" style={{
                    fontFamily: "Montserrat, sans-serif",
                    //fontSize: "18px",
                    color: "#009ED0",
                    padding: "5px 10px",
                    border: "none",
                    borderRadius: "0px",
                    textTransform: "uppercase",
                    fontWeight: "bold"
                  }}>
                    Apply
                  </button>
                </div>
              </div>
              <div style={{ paddingBottom: "30px" }}></div>
            </section>
          </div >
          <section>
            <div style={{
              fontFamily: "Montserrat, sans-serif",
              textTransform: "none",
              fontStyle: "normal",
              color: "white",
              paddingBottom: "10px",
              background: "#2D2D2D",
              padding: "0px 20px",
              paddingTop: "20px"
            }}>
              <div>
                <p className="leading-tight text-xxm sm:text-xl" style={{
                  color: "white",
                  textTransform: "uppercase",
                  //fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat, sans-serif",
                  paddingBottom: "16px"
                }}>Subtotal: ${subtotal}</p>
              </div>
              <div style={{
                fontFamily: "Montserrat, sans-serif",
                textTransform: "none",
                fontStyle: "normal",
                color: "white",
                paddingBottom: "20px",
              }}>
                <button style={{
                  width: "auto",
                  maxWidth: "100%",
                  fontFamily: "Montserrat, sans-serif",
                  textTransform: "uppercase",
                  letterSpacing: "2.5px",
                  fontSize: ".8rem",
                  height: "40px",
                  background: "#009ED0",
                  border: "none",
                  borderRadius: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "12px", // Adjust padding here
                  ...(window.innerWidth <= 540 && {
                    fontSize: '0.8rem', // Decrease font size on small screens
                    padding: "10px", // Override Elementor padding for smaller screens
                  })
                }}
                  onClick={() => { handleCheckout(); }}
                >
                  Go To CheckOut
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                  </svg>
                </button>
              </div>
              <div>
                <p style={{
                  color: "white",
                  letterSpacing: "1px",
                  lineHeight: "1",
                  fontSize: "1rem",
                  fontFamily: "Montserrat, sans-serif",
                  fontStyle: "italic",
                }}>
                  {eventChosen && eventChosen.length > 0 && eventChosen[0].start && (
                    `You are buying tickets for ${formatDateTwo(eventChosen[0].start)} at ${getTimeNumber(eventChosen[0].start)}`
                  )}
                </p>
              </div>
              <div style={{ paddingBottom: "20px" }}></div>
            </div>
          </section>
        </div >

        {/* Event Info Section */}
        < section className='flex flex-col sm:flex-row' id="EventInfo" style={{
          fontFamily: "Montserrat, sans-serif",
          textTransform: "none",
          fontStyle: "normal",
          color: "white",
          paddingTop: "20px",
          paddingBottom: "40px",
          margin: "0", // Add margin
        }}>
          {/* Event Info */}
          < div className="w-full" style={{ marginBottom: "20px" }}>
            <h4 style={{
              color: "white",
              fontSize: "24px",
              paddingBottom: "12px"
            }}>Event Info:</h4>
            {
              selectedDate.length > 0 && (
                <p style={{
                  fontFamily: "Montserrat, sans-serif",
                  textTransform: "none",
                  fontStyle: "normal",
                  color: "white",
                  paddingBottom: "10px",
                  paddingRight: "0px",
                  margin: "0", // Add margin
                  fontSize: "18px", // Adjusted font size to match video height
                }}>{selectedDate[0].description}</p>
              )
            }
          </div >
          {/* Video */}
          < div className="w-full" style={{
            fontFamily: "Montserrat, sans-serif",
            textTransform: "none",
            fontStyle: "normal",
            color: "white",
            paddingBottom: "10px",
            margin: "0",
          }}>
            {
              selectedDate.length > 0 && selectedDate[0].attribute_VideoLink && ( // Check if video link exists
                <iframe
                  width="500"
                  height="400"
                  src={`https://www.youtube.com/embed/${extractVideoId(selectedDate[0].attribute_VideoLink)}`}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              )
            }
          </div >
        </section >
      </div >
    </>
  );
}